import React from 'react';
import './utils/dayjs';
import '@mantine/core/styles.css';
import '@mantine/dates/styles.css';
import '@mantine/core/styles.layer.css';
import 'mantine-datatable/styles.layer.css';
import '@mantine/charts/styles.css';
import {MantineProvider} from "@mantine/core";
import {DatesProvider} from "@mantine/dates";
import {Shell} from "./components/shell/Shell";
import {useConfigStore} from "./store/configStore";
import {ModalsProvider} from "@mantine/modals";
import {Notifications} from "@mantine/notifications";
import {pangolinTheme} from "./theme/pangolinTheme";
import '@mantine/notifications/styles.css';

function App() {
    const config = useConfigStore();

    return (
        <MantineProvider theme={pangolinTheme} forceColorScheme={config.theme}>
            <DatesProvider settings={{locale: 'en'}}>
                <ModalsProvider>
                    <Notifications/>
                    <Shell/>
                </ModalsProvider>
            </DatesProvider>
        </MantineProvider>
    );
}

export default App;
